// Encryption utilities with Unicode support
const ENCRYPTION_KEY = '89f7d2e1c3b5a4';

export function encryptString(text: string): string {
  const encoded = encodeURIComponent(text);
  const textChars = encoded.split('');
  const keyChars = ENCRYPTION_KEY.split('');
  const encrypted = textChars.map((char, i) => {
    const keyChar = keyChars[i % keyChars.length];
    return String.fromCharCode(char.charCodeAt(0) ^ keyChar.charCodeAt(0));
  });
  
  return encodeURIComponent(encrypted.join(''));
}

export function decryptString(encrypted: string): string {
  const decoded = decodeURIComponent(encrypted);
  const encryptedChars = decoded.split('');
  const keyChars = ENCRYPTION_KEY.split('');
  const decrypted = encryptedChars.map((char, i) => {
    const keyChar = keyChars[i % keyChars.length];
    return String.fromCharCode(char.charCodeAt(0) ^ keyChar.charCodeAt(0));
  });
  
  return decodeURIComponent(decrypted.join(''));
}